import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {ViewService} from '../../../../shared/service/view.service';
import {PlayerProfileService} from '../../../service/player-profile.service';
import {RestErrorHelper} from '../../../../../helper/rest-error-helper';
import {PlayerProfile} from '../../../model/player-profile';
import {LoadingComponent} from '../../../../../components/generic/loading/loading.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FunctionsService} from '../../../../../services/functions.service';
import {MenuItem} from 'primeng/api';
import {PlayerProfileAccountDataComponent} from './player-profile-account-data/player-profile-account-data.component';
import {
  PlayerProfileAccountPersonalDataComponent
} from './player-profile-account-personal-data/player-profile-account-personal-data.component';
import {
  FrontendNavigationComponent
} from '../../../../frontend/player-frontend/frontend-navigation/frontend-navigation.component';
import {PLAYER_PREFIX_FULL} from '../../../player.routes';
import {
  PlayerProfileAccountPaymentsComponent
} from './player-profile-account-payments/player-profile-account-payments.component';
import {
  PlayerProfileAccountLinksComponent
} from './player-profile-account-links/player-profile-account-links.component';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-player-profile-account',
  standalone: true,
  imports: [
    LoadingComponent,
    FormsModule,
    ReactiveFormsModule,
    PlayerProfileAccountDataComponent,
    PlayerProfileAccountPersonalDataComponent,
    FrontendNavigationComponent,
    PlayerProfileAccountPaymentsComponent,
    PlayerProfileAccountLinksComponent
  ],
  templateUrl: './player-profile-account.component.html',
  styleUrl: './player-profile-account.component.scss'
})
export class PlayerProfileAccountComponent implements OnInit
{
  public view = inject(ViewService);
  public playerProfileService = inject(PlayerProfileService);
  private restErrorHelper = inject(RestErrorHelper);
  private functionsService = inject(FunctionsService);
  private destroyRef = inject(DestroyRef);

  isLoading: boolean;
  playerProfile: PlayerProfile;
  navigationItems: MenuItem[];
  activeItem: MenuItem;

  constructor()
  {
    this.playerProfileService.inAppPurchaseComplete$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.loadData(false));
  }

  ngOnInit(): void
  {
    // this.initNavigationItems();
    this.loadData(true);
  }

  private initNavigationItems(): void
  {
    this.navigationItems = [
      {
        label: this.view.isMobile ? 'PROFILE' : 'PROFILE_DATA',
        routerLink: PLAYER_PREFIX_FULL + '/profile/account/data',
        url: 'data',
        icon: 'pi pi-user',
      },
      {
        label: this.view.isMobile ? 'DATA' : 'PERSONAL_DATA',
        routerLink: PLAYER_PREFIX_FULL + '/profile/account/personalData',
        url: 'personalData',
        icon: 'pi pi-id-card',
      },
      {
        label: this.view.isMobile ? 'LINKS' : 'PLAYER_LINKS',
        routerLink: PLAYER_PREFIX_FULL + '/profile/account/links',
        url: 'links',
        icon: 'pi pi-link',
      },
    ];

    if (!this.playerProfile?.hidePayments)
    {
      this.navigationItems.push(
        {
          label: 'PAYMENTS',
          routerLink: PLAYER_PREFIX_FULL + '/profile/account/payments',
          url: 'payments',
          icon: 'pi pi-wallet',
        }
      );
    }
    console.log('navigationItems:', this.navigationItems);
  }

  public onNavigationItemChanged(data: any): void
  {
    this.activeItem = data;
  }

  public loadData(checkInAppPurchase: boolean): void
  {
    this.isLoading = true;
    this.playerProfileService.loadProfileData().subscribe({
      next: (response: PlayerProfile) =>
      {
        console.log('PlayerProfile geladen', response);
        this.playerProfile = response;
        this.initNavigationItems();
        this.isLoading = false;

        if (checkInAppPurchase)
          this.playerProfileService.checkInAppPurchaseProfile();
      },
      error: error =>
      {
        console.log('Fehler bei "loadProfileData"', error);
        this.isLoading = false;
        this.restErrorHelper.handleErrorService(error);
      }
    });
  }

  public onUpdatePlayerProfileValue(data: any): void
  {
    console.log('onUpdatePlayerProfileValue, data: ', data);
    this.updatePlayerProfileValue(data.body, data.inputField);
  }

  public updatePlayerProfileValue(body: any, inputField?: any): void
  {
    console.log('updatePlayerProfileValue', body);
    if (inputField)
      inputField.disabled = true;

    this.playerProfileService.updateProfileField(body, true).subscribe({
      next: data =>
      {
        console.log('Daten erfolgreich geändert', data);
        if (inputField)
          inputField.disabled = false;

        if (body.postalCode)
          this.plzChanged();

        // this.playerSessionService.playerProfileObject = this.playerProfile;
      },
      error: error =>
      {
        this.restErrorHelper.handleErrorService(error);
        if (inputField)
          inputField.disabled = false;
      }
    });
  }

  public plzChanged(): void
  {
    if (this.playerProfile.postalCode?.length === 5)
    {
      this.functionsService.getPlzDetailsAnyBackend(this.playerProfile.postalCode).subscribe({
        next: data =>
        {
          if (data?.city)
          {
            this.playerProfile.city = data.city;
            this.updatePlayerProfileValue({ city: this.playerProfile.city});
          }
        },
        error: error => this.restErrorHelper.handleErrorService(error)
      });
    }
  }

}
